import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Calendar, Clock, ArrowRight } from "lucide-react";
import PageHeader from "../components/PageHeader";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Blogs() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/blogs`)
      .then((r) => setPosts(r.data))
      .catch((e) => console.error(e))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="blogs-page">
      <PageHeader
        eyebrow="Blog"
        title="Insights for smarter Naira–CAD transfers."
        subtitle="Guides, market notes, and compliance explainers — written for senders and recipients."
      />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
        {loading ? (
          <div className="text-slate-500" data-testid="blogs-loading">Loading articles…</div>
        ) : posts.length === 0 ? (
          <div className="text-slate-500">No posts yet.</div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {posts.map((p) => (
              <Link
                key={p.slug}
                to={`/blogs/${p.slug}`}
                data-testid={`blog-card-${p.slug}`}
                className="group rounded-2xl border border-slate-200 overflow-hidden hover:shadow-lg hover:-translate-y-0.5 transition-all bg-white"
              >
                <div className="aspect-[16/10] overflow-hidden bg-slate-100">
                  <img
                    src={p.cover_image}
                    alt={p.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-4 text-xs text-slate-500">
                    <span className="inline-flex items-center gap-1"><Calendar size={12} /> {new Date(p.published_at).toLocaleDateString("en-CA", { year: "numeric", month: "short", day: "numeric" })}</span>
                    <span className="inline-flex items-center gap-1"><Clock size={12} /> {p.read_minutes} min read</span>
                  </div>
                  <h3 className="font-display text-lg font-bold text-[#0B192C] mt-3 group-hover:text-[#FF6B00] transition-colors">{p.title}</h3>
                  <p className="mt-2 text-sm text-slate-600 line-clamp-3">{p.excerpt}</p>
                  <div className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-[#FF6B00]">
                    Read article <ArrowRight size={14} />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
